import type { GateFields } from '../types/wizard.types';
import { maskMoney, parseMoney } from './masks';

export const GATE_BREAKDOWN_KEYS = [
  'productAmount',
  'preparationMaterial',
  'deliveryAmount',
  'installationAmount',
  'preparationWork',
  'demontageAmount',
] as const satisfies ReadonlyArray<keyof GateFields>;

export function sumGateBreakdown(gate: Pick<GateFields, (typeof GATE_BREAKDOWN_KEYS)[number]>): number {
  return GATE_BREAKDOWN_KEYS.reduce((sum, key) => sum + parseMoney(gate[key]), 0);
}

export function formatGateTotal(gate: Pick<GateFields, (typeof GATE_BREAKDOWN_KEYS)[number]>): string {
  const total = sumGateBreakdown(gate);
  if (total <= 0) return '';
  return maskMoney(total.toFixed(2).replace('.', ','));
}

export function sumGateBreakdownNumbers(gate: {
  productAmount: number;
  preparationMaterial: number;
  deliveryAmount: number;
  installationAmount: number;
  preparationWork: number;
  demontageAmount: number;
}): number {
  return (
    gate.productAmount
    + gate.preparationMaterial
    + gate.deliveryAmount
    + gate.installationAmount
    + gate.preparationWork
    + gate.demontageAmount
  );
}
